import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PublicNavigation = () => {
  const navigate = useNavigate();
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

  const handleLogin = () => {
    navigate('/enter');
  };

  const hideMobileMenu = () => {
    setMobileMenuVisible(false);
  };

  const showMobileMenu = () => {
    setMobileMenuVisible(true);
  };

  return (
    <>
      {/* Навигация */}
      <div style={{ 
        background: '#0f1113', 
        padding: '0 24px',
        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.35)',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        borderBottom: '2px solid #1a472a'
      }}>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          height: '64px',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          {/* Логотип */}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h1 
              style={{ 
                fontSize: '24px', 
                color: '#e8e8e8', 
                margin: 0,
                cursor: 'pointer',
                fontWeight: '700',
                transition: 'color 0.3s ease'
              }}
              onClick={() => navigate('/')}
              onMouseEnter={(e) => {
                e.target.style.color = '#b5b9bf';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = '#e8e8e8';
              }}
            >
              LimitVerify
            </h1>
          </div>

          {/* Десктопное меню */}
          <div className="desktop-menu" style={{ 
            display: 'flex', 
            alignItems: 'center',
            gap: '16px'
          }}>
            <button 
              onClick={() => navigate('/')}
              style={{
                background: 'transparent',
                color: '#e8e8e8',
                border: 'none',
                padding: '10px 16px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '500',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#1a472a';
                e.target.style.color = '#ffffff';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = '#e8e8e8';
              }}
            >
              Главная
            </button>
            <button 
              onClick={handleLogin}
              style={{
                background: '#8c1913',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '500',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 8px rgba(140, 25, 19, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#a52a2a';
                e.target.style.transform = 'translateY(-1px)';
                e.target.style.boxShadow = '0 4px 12px rgba(140, 25, 19, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = '#8c1913';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 2px 8px rgba(140, 25, 19, 0.3)';
              }}
            >
              Вход в кабинет клиента
            </button>
          </div>

          {/* Мобильное меню - кнопка гамбургер */}
          <div className="mobile-menu-button">
            <button 
              onClick={showMobileMenu}
              style={{
                background: 'transparent',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                padding: '8px',
                color: '#e8e8e8'
              }}
            >
              ☰
            </button>
          </div>
        </div>
      </div>

      {/* Мобильное меню - Drawer */}
      {mobileMenuVisible && (
        <div style={{
          position: 'fixed',
          top: 0,
          right: 0,
          width: '280px',
          height: '100vh',
          background: '#0f1113',
          boxShadow: '-2px 0 8px rgba(0,0,0,0.35)',
          zIndex: 1001,
          padding: '24px',
          borderLeft: '2px solid #1a472a'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '32px'
          }}>
            <h2 style={{ margin: 0, color: '#e8e8e8' }}>Меню</h2>
            <button 
              onClick={hideMobileMenu}
              style={{
                background: 'transparent',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#e8e8e8'
              }}
            >
              ×
            </button>
          </div>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <button 
              onClick={() => { navigate('/'); hideMobileMenu(); }}
              style={{
                background: 'transparent',
                color: '#e8e8e8',
                border: 'none',
                padding: '14px 20px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '16px',
                textAlign: 'left',
                fontWeight: '500',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#1a472a';
                e.target.style.color = '#ffffff';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = '#e8e8e8';
              }}
            >
              Главная
            </button>
            <button 
              onClick={() => { handleLogin(); hideMobileMenu(); }}
              style={{
                background: '#8c1913',
                color: 'white',
                border: 'none',
                padding: '14px 20px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '16px',
                textAlign: 'left',
                fontWeight: '500',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 8px rgba(140, 25, 19, 0.3)'
              }}
            >
              Вход в кабинет клиента
            </button>
          </div>
        </div>
      )}

      {/* Overlay для мобильного меню */}
      {mobileMenuVisible && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.5)',
            zIndex: 1000
          }}
          onClick={hideMobileMenu}
        />
      )}
    </>
  );
};

export default PublicNavigation;
